export enum GamesTabsPathNames {
  LOBBY = "/games",
  SLOTS = "/games/slots",
  CHALLENGES = "/games/slots?filter=challenges",
  WREWARDS_HOT = "/games/slots?filter=hot",
  FAVORITE_SLOTS = "/games/slots?filter=favorite",
  NEW_RELEASES = "/games/slots?filter=new",
}
